import React, { useState, useEffect } from 'react'
import Api from '../../../../_helpers/Api'
import { trans } from '../../../../_providers/Translation'
// import '../../../../assets/css/ReservationStats.css'
import LatestReservations from './LatestReservations'
import StatusDiagram from './StatusDiagram'
import ReservationMetrics from './ReservationMetrics'
import NoDataFound from '@/components/partials/NoDataFound'
import { Tooltip } from '@mui/material'
import Skeleton from 'react-loading-skeleton'

const ReservationStats = () => {
    const [stats, setStats] = useState(null)
    const [loading, setLoading] = useState(true)
    const [error, setError] = useState(null)
    const [selectedStatus, setSelectedStatus] = useState(null)

    useEffect(() => {
        fetchReservationStats()
    }, [])

    const fetchReservationStats = async () => {
        try {
            setLoading(true)
            const response = await Api.get('dashboard/reservation-stats')
            setStats(response.data)
            setError(null)
        } catch (err) {
            console.error('Error fetching reservation stats:', err)
            setError('Failed to load reservation statistics')
        } finally {
            setLoading(false)
        }
    }

    const calculateStackedBar = () => {
        if (!stats || !stats.stats || stats.total === 0) return []

        let cumulativePercentage = 0

        return stats.stats.map((item) => {
            const percentage = stats.total > 0 ? (item.count / stats.total) * 100 : 0
            const startPosition = cumulativePercentage
            const endPosition = cumulativePercentage + percentage
            const centerPosition = startPosition + (percentage / 2)

            cumulativePercentage += percentage

            return {
                ...item,
                percentage: Math.round(percentage * 10) / 10, // Round to 1 decimal
                startPosition,
                endPosition,
                centerPosition
            }
        })
    }

    const handleClearFilter = () => {
        setSelectedStatus(null)
    }

    const stackedData = calculateStackedBar()

    const handleSegmentClick = (item) => {
        if (selectedStatus && selectedStatus.id === item.id) {
            setSelectedStatus(null)
        } else {
            setSelectedStatus(item)
        }
    }

    return (
        <div className="reservation-stats-container">
            <h3>{trans('headings.reservations')}</h3>
            <hr />
            {loading ?
                <Skeleton count={5} height={100} />
                :
                !stats || !stats.stats || stats.stats.length === 0 ?
                    <div
                        className="alert info"
                        style={{
                            marginBottom: 0,
                            width: '100%',
                        }}
                    >
                        {trans("messages.noDataFound")}
                    </div>
                    :
                    <div className="reservation-stats-content">

                        <div className="stacked-bar-wrapper">
                            <div className="stacked-bar-container">
                                {stackedData.map((item, index) => (
                                    <Tooltip
                                        classes={{ tooltip: 'dashboard-stats-tooltip' }}
                                        arrow key={item.id || index}
                                        title={<>
                                            <p>
                                                {item.name}
                                            </p>
                                            <b>
                                                {item.count}
                                            </b>
                                        </>}
                                        followCursor
                                    >
                                        <div
                                            className={`stacked-bar-segment ${selectedStatus && selectedStatus.id === item.id ? 'selected' : ''}`}
                                            style={{
                                                width: `${item.percentage}%`,
                                                backgroundColor: item.color,
                                            }}
                                            onClick={() => handleSegmentClick(item)}
                                        />
                                    </Tooltip>
                                ))}
                            </div>
                        </div>

                        <div className="reservation-stats-legend">
                            {stats.legend && (() => {
                                const itemsPerColumn = 4
                                const columns = []

                                for (let i = 0; i < stats.legend.length; i += itemsPerColumn) {
                                    const columnItems = stats.legend.slice(i, i + itemsPerColumn)
                                    columns.push(
                                        <div key={i} className="legend-column">
                                            {columnItems.map((item, index) => (
                                                <div key={item.name + index} className="legend-item">

                                                    <div className="legend-details">
                                                        <div
                                                            className="legend-color"
                                                            style={{ backgroundColor: item.color }}
                                                        ></div>
                                                        <div className="legend-name">{item.name}</div>

                                                    </div>
                                                    <div className="legend-count">{item.count}</div>
                                                </div>
                                            ))}
                                        </div>
                                    )
                                }

                                return columns
                            })()}
                        </div>

                        <hr />

                        <div className='row'>
                            <ReservationMetrics />
                        </div>
                        <div className='row'>
                            <div className="col">
                                <StatusDiagram
                                    title={trans('labels.initialStatus')}
                                    endpoint="dashboard/diagram/status_initial"
                                />
                            </div>
                            <div className="col">
                                <StatusDiagram
                                    title={trans('labels.finalStatus')}
                                    endpoint="dashboard/diagram/status_final"
                                />
                            </div>
                        </div>

                        <div className='row'>
                            <div className='col'>
                                <LatestReservations
                                    statusFilter={selectedStatus}
                                    onClearFilter={handleClearFilter}
                                />
                            </div>
                        </div>

                    </div>
            }
        </div>
    )
}

export default ReservationStats